export const setToken = (token) => {
    sessionStorage.setItem('Token', token);
    return 0;
}

export const getToken = () => {
    return sessionStorage.getItem('Token');
    // console.log("Token: ", token);
}

export const setRefreshToken = (token) => {
    sessionStorage.setItem('RefreshToken', token);
    return 0;
}

export const getRefreshToken = () => {
    return sessionStorage.getItem('RefreshToken');
    // console.log("Token: ", token);
}

export const clearToken = () => {
    sessionStorage.clear();
    localStorage.clear();
}
